import styled from 'styled-components'

import { TrUnstyled } from 'Components/Table/Tr/unstyled'

export const Tr = styled(TrUnstyled)`
  height: 48px;

  cursor: ${props => props.clickable && 'pointer'};
  background: ${props => props.theme.colors.white};

  &:nth-child(2n-1),
  .active td {
    background: ${props => props.theme.colors.alabaster};
  }
  &.active {
    background-color: ${props => props.theme.colors.primary};
    a {
      color: ${props => props.theme.colors.white};
    }
    svg {
      fill: ${props => props.theme.colors.white};
    }
  }
`
